"use client";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Spinner } from "@/components/ui/spinner";
import { REQUEST_PARAMS, UI } from "@/constants";
import { useSetQuery } from "@/hooks";
import { getDefaultParams } from "@/lib";
import { ChevronDownIcon } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { memo } from "react";

const DEFAULT_PARAMS = getDefaultParams();

type LimitSelectProps = {
  label?: string;
};

export const LimitSelect = memo(({ label }: LimitSelectProps) => {
  const { setQuery, isPending } = useSetQuery();
  const searchParams = useSearchParams();
  const currentLimit = searchParams.get(REQUEST_PARAMS.size) || DEFAULT_PARAMS.size;

  return (
    <Select
      value={currentLimit}
      onValueChange={value => setQuery({ size: value }, { reset: true })}
      disabled={isPending}
    >
      <SelectTrigger size="sm" aria-label={label} className="[&>svg:last-child]:hidden font-medium">
        <SelectValue />
        {isPending ? <Spinner /> : <ChevronDownIcon className="text-foreground" />}
      </SelectTrigger>
      <SelectContent>
        {UI.options.size.map(limit => (
          <SelectItem key={limit} value={limit}>
            {limit} {label || ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

LimitSelect.displayName = "LimitSelect";
